import { EVENT_TYPE } from '@atlaskit/editor-common/analytics';
import { type ExtractInjectionAPI } from '@atlaskit/editor-common/types';
import { type EditorView } from '@atlaskit/editor-prosemirror/view';

import { addAnalytics } from '../../../analytics/utils';
import { CONFIG_ITEM_KEYS } from '../../../config-items/config-item-keys';
import { type AIPlugin } from '../../../editor-plugin-ai';

export const firePromptConfigNotFoundError = ({
	editorView,
	dispatch,
	prompt,
	adjustSelection,
	promptText,
}: {
	editorView: EditorView;
	dispatch: EditorView['dispatch'];
	prompt?: string;
	promptText?: string;
	adjustSelection?: string;
}) => {
	const errorEventTr = addAnalytics({
		editorState: editorView.state,
		tr: editorView.state.tr,
		payload: {
			action: 'error',
			actionSubject: 'editorPluginAI',
			actionSubjectId: 'eventHubPlugin',
			attributes: {
				errorType: 'promptConfigItemNotFound',
				prompt: prompt,
				promptText: promptText,
				adjustSelection: adjustSelection,
			},
			eventType: EVENT_TYPE.OPERATIONAL,
		},
	});
	dispatch(errorEventTr);
};

export const fireFallbackSuggestedTitleReturnedEvent = ({
	api,
	analyticSourceId,
}: {
	api: ExtractInjectionAPI<AIPlugin> | undefined;
	analyticSourceId: string;
}) => {
	api?.analytics?.actions.fireAnalyticsEvent({
		// @ts-expect-error - Temporarily added analytic event for proactive title generation project
		action: 'streamingCompleted',
		// @ts-expect-error - Temporarily added analytic event for proactive title generation project
		actionSubject: 'editorPluginAI',
		// @ts-expect-error - Temporarily added analytic event for proactive title generation project
		actionSubjectId: 'eventHubPlugin',
		attributes: {
			promptType: CONFIG_ITEM_KEYS.SUGGEST_A_TITLE,
			modalHidden: true,
			fallbackSuggestedTitleReturned: true,
			analyticSourceId,
		},
		eventType: EVENT_TYPE.TRACK,
	});
};
